import { FreshAsphalt, FreshAsphalt50, SpbSky0, SpbSky1 } from './palette';

/*
* -------------------------------------------
*            ACCOUNT CONTROLLER
* -------------------------------------------
*/

export const expensesAnalyzerAccountControllerBgColor = SpbSky0;
export const expensesAnalyzerAccountControllerBorderColor = SpbSky1;
export const expensesAnalyzerTextColor = FreshAsphalt;
export const expensesAnalyzerTextColorSecondary = FreshAsphalt50;
